import { readStorage, setStorage } from '@surglogs/hook.storage'

import { getClinicIdKey, getUserIdKey } from './storageKeys'

export const getClinicIdFromStorage = (userId: string | number | null) =>
  readStorage<string>(window.localStorage, getClinicIdKey(userId))

export const getUserIdFromStorage = () => {
  const key = getUserIdKey()
  const fromSession = readStorage<string>(window.sessionStorage, key)

  if (fromSession) return fromSession

  const fromLocal = readStorage<string>(window.localStorage, key)

  if (fromLocal) {
    setStorage(window.sessionStorage, key, fromLocal)
    window.localStorage.removeItem(key)
  }

  return fromLocal
}

export const setUserIdToStorage = (userId: string | number | null) =>
  setStorage(window.sessionStorage, getUserIdKey(), userId)

export const setClinicIdToStorage = (
  clinicId: number | null,
  userId: string | number | null,
) => setStorage(window.localStorage, getClinicIdKey(userId), clinicId)
